import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  modalRoot: {
    [theme.breakpoints.up('lg')]: {
      height: '80vh',
    },
  },
  button: {
    '&.Mui-disabled': {
      pointerEvents: 'auto',
    },
    [theme.breakpoints.down('md')]: {
      height: '38px',
    },
  },
}));
